import img1 from '../assets/Page7/news__news-image.png'
import img2 from '../assets/Page7/news__news-image (1).png'
import img3 from '../assets/Page7/news__news-image (2).png'
import img4 from '../assets/Page7/news__news-image (3).png'
import img5 from '../assets/Page7/news__news-image (4).png'
import img6 from '../assets/Page7/news__news-image (5).png'
import img7 from '../assets/Page7/news__news-image (6).png'
import img8 from '../assets/Page7/news__news-image (7).png'
import img9 from '../assets/Page7/news__news-image (8).png'
import img10 from '../assets/Page7/news__news-image (9).png'
import img11 from '../assets/Page7/news__news-image (10).png'
import img12 from '../assets/Page7/news__news-image (11).png'
import img13 from '../assets/Page7/news__news-image (12).png'
import img14 from '../assets/Page7/news__news-image (13).png'
import img15 from '../assets/Page7/news__news-image (15).png'
import img16 from '../assets/Page7/news__news-image (16).png'
import img17 from '../assets/Page7/news__news-image (17).png'



export const newsData = [
    {
        imgUrl: img1,
        category: 'NEWS',
        text1:"See This Month's Winners",
        
    },
    {
        imgUrl: img2,
        category: 'UPDATE',
        text1:"Battlefield V Summer Update",
        
    },
    {
        imgUrl: img3,
        category: 'UPDATE',
        text1:"Battlefield V Chapter 6: Update",
        text2:'#3'
    },
    {
        imgUrl: img4,
        category: 'NEWS',
        text1:"Fan-Made Image Gallery",
    },
    {
        imgUrl: img5,
        category: 'UPDATE',
        text1:"Battlefield V Chapter 6: Update",
        text2:'#3'
    },
    {
        imgUrl: img6,
        category: 'NEWS',
        text1:"Ready To Go Into The Jungle?",
    },
    {
        imgUrl: img7,
        category: 'NEWS',
        text1:"Explore The Wake Island Map",
    },
    {
        imgUrl: img8,
        category: 'NEWS',
        text1:"Learn About Community Games",
    },
    {
        imgUrl: img9,
        category: 'NEWS',
        text1:"Learn All About Wake Island",
    },
    {
        imgUrl: img10,
        category: 'NEWS',
        text1:"Learn About New Weapons",
    },
    {
        imgUrl: img11,
        category: 'NEWS',
        text1:"Explore The War In The Pacific",
    },
    {
        imgUrl: img12,
        category: 'NEWS',
        text1:"Explore Opearation Underground",
    },
    {
        imgUrl: img13,
        category: 'UPDATE',
        text1:"Defying The Odds Update #5",
        text2:"Notes",
    },
    {
        imgUrl: img14,
        category: 'UPDATE',
        text1:"Defying The Odds Update #4",
        text2:"Notes",
    },
    {
        imgUrl: img15,
        category: 'LETTERS FROM THE FRONT UPDATE',
        text1:"News",
    },
    {
        imgUrl: img16,
        category: 'NEWS',
        text1:"Get The Intel On 2 New Maps",
    },
    {
        imgUrl: img17,
        category: 'UPDATE',
        text1:"Defying The Odds Update #2",
        text2:"Notes",
    },
    
]